<template>
  <div class='zhizhao'>
    <h3>走进百生跃</h3>
    <div v-html="list.content">{{list.content}}</div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      list:[]
    }
  },
  created() {
    this.$api.singlePage.page({
      type:"about"
    }).then(res=>{
      this.list = res.data
    })
  },
}
</script>

<style lang="less" scoped>
  .zhizhao{
      width: 100%;
      height:100%;
      h3{
        font-size: 24px;
        text-align: left;
        color: #333333;
        margin-bottom: 20px;
      }
      p{
        img{
            width: 876px;
            height: 505px;
        }  
      }
  }
</style>